<template>
    <div class="container">
        <div class="row pt-10 pb-5">
            <div class="col-sm-9 text-left">
                <h4 class="heading">{{ message }}</h4>
                <hr />
                <div v-show="this.status">
                    <p>
                        Please click on continue to proceed with registration
                        process
                    </p>
                    <button
                        type="button"
                        @click="next"
                        class="btn btn-default btn1"
                    >
                        CONTINUE
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../api/api.js";

export default {
    name: "EmailVerification",

    data() {
        return {
            message: "Please Wait...",
            status: false,
            orgExist: false,
        };
    },

    created() {
        this.verifyEmailCheck();
        this.unsubscribe = this.$store.subscribe((mutation) => {
            if (mutation.type === "setUser" && mutation.payload !== null) {
                if (JSON.parse(this.$store.state.user)) {
                    if (
                        JSON.parse(this.$store.state.user).organizationRequest
                    ) {
                        this.orgExist = true;
                    }
                    this.status = true;
                }
            }
        });
    },
    unmounted() {
        this.unsubscribe();
    },

    methods: {
        ...mapActions(["getUser"]),

        verifyEmailCheck() {
            if (this.$route.query.reqid && this.$route.query.otp) {
                api.verifyEmail(this.$route.query)
                    .then((response) => {
                        if (
                            response &&
                            response.status &&
                            response.status === 200
                        ) {
                            this.message = response.data.message;
                            if (response.data.status) {
                                this.getUser(response.data.email);
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.message = "An Error Occurred Please Try Again";
                    });
            }
        },

        next() {
            this.$gtag.event("EmailVerification", {
                event_category: "general",
                event_label: "Email Verification Done",
                value: JSON.parse(this.$store.state.user).email,
            });
            if (this.orgExist === true) {
                this.$router.push({ path: "/organizationaccount" });
            } else {
                this.$router.push({ path: "/accountview" });
            }
        },
    },
};
</script>

<style scoped>
.container {
    box-sizing: border-box;
    max-width: 1123px;
    font-size: 16px;
    line-height: 24px;
    color: #5a7d95;
    padding-top: 3%;
    padding-bottom: 12%;
}

.heading {
    font-weight: 700;
    font-size: 29px;
    line-height: 34px;
    color: #1978a0;
}

hr {
    border: 2px solid #d8d8d8;
}

.btn1 {
    background: #019382;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #ffffff;
    width: 319px;
    height: 45px;
}

.list-group-item {
    text-align: left;
    background: #f6f5f5;
    font-size: 16px;
    line-height: 19px;
    color: #5a7d95;
}

.list-group .active {
    background: #1978a0;
    color: #ffffff;
}
@media (max-width: 600px){
    .heading{
        font-size: 18px !important;
    }
    .btn1 {

        width: 66.78% !important;
        font-size: 80% !important;

    }
}
</style>
